export function flashScreen(k) {
    const flashRect = k.add([
        k.rect(k.width(), k.height()),
        k.color(255, 255, 255),
        k.opacity(1),
        k.fixed(),
        k.z(100),
    ]);

    k.tween(1, 0, 0.3, (val) => flashRect.opacity = val)
        .then(() => k.destroy(flashRect));
}